// @ts-nocheck

"use client"

import React, { useState } from "react"
import Link from "next/link"
import { Formik, Field, Form } from "formik"
import { postContactFormQuery } from "@/queries/contact/form"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./styles.scss"

const ContactForm = () => {
    return (
        <section className="contact-form__wrapper">
            <div className="contact-form__container">
                <div className="contact-form__header">
                    <h5 className="text-[18px] font-bold font-['Comfortaa'] tracking-[0.25rem] leading-[20px] text-[#212121] text-center uppercase w-full">
                        OUR TEAM IS HERE TO ANSWER ALL OF YOUR QUESTIONS. 
                    </h5>
                    <h4 className="text-[36px] font-bold font-['Didot'] tracking-[0rem] leading-[42px] text-[#212121] text-center uppercase w-full">
                        CONTACT FORM
                    </h4>
                </div>
                <div className="contact-form__form">
                    <Formik
                        initialValues={{
                            name: '',
                            email: '',
                            phone: '',
                            direct: '+34',
                            message: '',
                            rodo_1: false,
                            rodo_2: false
                        }}
                        onSubmit={(values) => {
                            if (values.email !== "dianawumannino@gmail.com") {
                                postContactFormQuery(
                                    values.email,
                                    values.message,
                                    values.name,
                                    values.rodo_1,
                                    values.rodo_2,
                                    `${values.direct} ${values.phone}`
                                )
                                    .then(response => {
                                        toast.success("Your message was sent successfully!", {
                                            toastId: "contact-send"
                                        })
                                    })
                                    .catch(error => console.warn(error))
                            }
                            
                        }}
                    >
                        <Form className="flex flex-col gap-5 justify-center items-center w-full">
                            <div className="flex flex-col lg:flex-row gap-5 justify-center items-center w-full">
                                <div className="flex flex-col gap-5 justify-center items-center w-full lg:w-1/2">
                                    <Field
                                        id="name"
                                        name="name"
                                        placeholder="FIRST NAME AND LAST NAME"
                                        className="border-[#212121] border-[0.5px] rounded-[25px] w-full h-[50px] bg-transparent px-5 placeholder:text-slate-900 placeholder:uppercase font-['Comfortaa'] text-[12px] lg:text-[14px] font-bold focus-visible:outline-none"
                                    />
                                    <div className="flex flex-row gap-5 justify-between items-center w-full">
                                        <Field
                                            id="direct"
                                            name="direct"
                                            placeholder="+34"
                                            className="border-[#212121] border-[0.5px] rounded-[25px] w-[85px] h-[50px] bg-transparent px-5 placeholder:text-slate-900 placeholder:uppercase font-['Comfortaa'] text-[14px] font-bold focus-visible:outline-none"
                                        />
                                        <Field
                                            id="phone"
                                            name="phone"
                                            placeholder="PHONE NUMBER"
                                            className="border-[#212121] border-[0.5px] rounded-[25px] w-full h-[50px] bg-transparent px-5 placeholder:text-slate-900 placeholder:uppercase font-['Comfortaa'] text-[12px] lg:text-[14px] font-bold focus-visible:outline-none"
                                        />
                                    </div>
                                    <Field
                                        id="email"
                                        name="email"
                                        placeholder="E-MAIL ADDRESS"
                                        type="email"
                                        className="border-[#212121] border-[0.5px] rounded-[25px] w-full h-[50px] bg-transparent px-5 placeholder:text-slate-900 placeholder:uppercase font-['Comfortaa'] text-[12px] lg:text-[14px] font-bold focus-visible:outline-none"
                                    />
                                </div>
                                <div className="flex flex-col gap-3 justify-center items-center w-full lg:w-1/2">
                                    <Field
                                        id="message"
                                        name="message"
                                        placeholder="MESSAGE CONTENT"
                                        type="text"
                                        className="border-[#212121] border-[0.5px] rounded-[25px] w-full h-[190px] bg-transparent px-5 placeholder:text-slate-900 placeholder:uppercase font-['Comfortaa'] text-[14px] font-bold focus-visible:outline-none"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col lg:flex-row gap-5 justify-center items-center w-full pt-1">
                                <div className="flex flex-col gap-5 justify-center items-center w-full lg:w-1/2">

                                </div>
                                <div className="flex flex-col gap-5 justify-start items-start w-full lg:w-1/2">
                                    <label className="contact-form__checkbox--label">
                                        I agree to receive communications from BeLuxe.*
                                        <Field type="checkbox" name="rodo_1" className="contact-form__checkbox" />
                                        <span className="contact-form__checkbox--checkmark" />
                                    </label>
                                    <label className="contact-form__checkbox--label">
                                        I have read and understood the <Link href="/privacy-policy" className="text-slate-900 font-bold underline ml-1">Terms and Conditions.*</Link>
                                        <Field type="checkbox" name="rodo_2" className="contact-form__checkbox" />
                                        <span className="contact-form__checkbox--checkmark" />
                                    </label>
                                </div>
                            </div>
                            <div className="flex flex-col lg:flex-col gap-12 justify-center items-center w-full pt-2">
                                <button
                                    type="submit"
                                    className="border-[#212121] border-[0.5px] w-[250px] h-[50px] rounded-[35px] uppercase font-['Comfortaa'] font-medium text-[14px] flex justify-center items-center hover:bg-[#212121] hover:text-[#E5E3DE] duration-300 ease-in-out"
                                >
                                    Send
                                </button>
                                <div className="border-t-[#212121] border-t-[0.5px] h-[1px] max-w-[665px] w-full" />
                            </div>
                        </Form>
                    </Formik>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </section>
    )
}

export default ContactForm